import script from "./UploadAddressList.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadAddressList.vue?vue&type=script&setup=true&lang=js"

import "./UploadAddressList.vue?vue&type=style&index=0&id=ce72df0e&lang=scss"

const __exports__ = script;

export default __exports__